<template>
    <div>
        <!-- filters -->
        <v-row class="mt-0">
            <!-- type -->
            <v-col
            	cols="12"
            	md="2"
            	sm="3"
            	align-self="center"
            	class="pe-1 pb-1"
                :class="{
    				'py-0': $vuetify.breakpoint.lgAndUp
    			}"
            >
                <v-autocomplete
                    v-model="typeAccount"
                    :items="type"
                    item-text="name"
                    item-value="accountId"
                    :label="$t('inputs.type')"
                    outlined
                    dense
                    hide-details="auto"
                    @change="getName()"
                    :loading="loading"
                    :disabled="submitLoading || loading"
                    prepend-icon="mdi-account-tie"
                    clearable
                />
            </v-col>

            <!-- employee -->
			<v-col 
				cols="12" 
				lg="2" 
				md="3" 
				sm="4" 
				align-self="center" 
                class="pa-1 pb-1"
				:class="{
    				'py-0': $vuetify.breakpoint.lgAndUp
    			}"
			>
                <v-autocomplete
                    v-model="name"
                    :items="typeAccount !== null ? names : []"
                    item-text="name"
                    item-value="accountId"
                    :label="$t('inputs.name')"
                    outlined
                    dense
                    hide-details
                    :loading="loading || submitLoading"
                    :disabled="submitLoading || loading"
                    clearable
               />
            </v-col>

            <!-- material -->
            <v-col
            	cols="12"
            	sm="4"
            	md="3"
            	lg="2"
            	align-self="center"
                class="pa-1 pb-1"
            >
                <v-autocomplete
                    v-model="item"
                    :label="$t('inputs.product-name')"
                    :items="materials"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                    :loading="loading"
                    :disabled="submitLoading || loading"
                    clearable
                />
            </v-col>

            <!-- start date -->
            <v-col
            	cols="12"
            	lg="2"
            	md="3"
            	sm="4"
            	align-self="center"
            	class="pa-1 pb-1"
            >
                <bee-date-picker
                    v-model="startDate"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        dense: true,
                        outlined: true,
                        prependIcon: 'mdi-calendar'
                    }"
                    :input-label="$t('inputs.start-date')"
                    :loading="loading"
                    :disabled="submitLoading || loading"
                    :allowed-dates="disableDates"
                ></bee-date-picker>
            </v-col>

            <!-- end date -->
            <v-col cols="12" lg="2" md="3" sm="4" align-self="center" class="pa-1 pb-1">
                <bee-date-picker
                    v-model="endDate"
                    menu-picker
                    dense
                    hide-details
                    :input-props="{
                        dense: true,
                        outlined: true,
                        prependIcon: 'mdi-calendar',
                        loading: loading
                    }"
                    :input-label="$t('inputs.end-date')"
                    :disabled="submitLoading || loading"
                    :allowed-dates="disableDates"
                ></bee-date-picker>
            </v-col>

            <!-- Pharmaceutical form -->
            <v-col v-if="0" cols="12" md="3" sm="4" align-self="center" class="pa-1 pb-1">
                <v-autocomplete
                    :items="materialForms"
                    item-text="name"
                    item-value="id"
                    :label="$t('inputs.pharmaceutical-form')"
                    dense
                    outlined
                    hide-details
                    :return-object="false"
                    clearable
                />
            </v-col>

            <v-col class="d-flex pb-1" align-self="center">
                <v-checkbox
                    v-model.number="isIn"
                    :label="$t('SamplesStatement.input')"
                    class="mt-0"
                    hide-details
                ></v-checkbox>
                <v-checkbox
                    v-model.number="isOut"
                    :label="$t('SamplesStatement.output')"
                    class="mt-0 ms-2"
                    hide-details
                ></v-checkbox>
                <!-- <v-radio-group
                    v-model.number="isInOrOut"
                    row
                    hide-details
                    class="mt-0"
                    :disabled="loading"
                >
                    <v-radio
                        label="Input"
                        :value="0"
                    ></v-radio>
                    <v-radio
                        label="Output"
                        :value="1"
                    ></v-radio>
                </v-radio-group> -->
            </v-col>

			<v-col class="d-flex py-0 justify-start" align-self="center" >
				<v-btn
					color="success"
					small
					class="mx-2"
                    :loading="loading"
                    :disabled="submitLoading || loading || isAllFieldsEmpty"
                    @click="resetAllFilter = false;needToResetItems = true; fetchAll();"
				>
					{{$t('search')}}
				</v-btn>

				<v-btn
					color="alert-color white--text"
					small
                    :loading="loading"
                    :disabled="submitLoading || loading"
                    @click="needToResetItems = true; reset(); fetchAll()"
				>
                    {{$t('reset')}}
				</v-btn>

                <v-btn
                    v-if="excelFile"
                    small
                    color="green lighten-1 white--text"
                    @click="importExcel"
                    class="mx-1"
                    :loading="loadingExcel"
                    :disabled="loadingExcel"
                >
                    <v-icon> mdi-file-table-outline </v-icon>
                    {{$t('export-excel')}}
                </v-btn>
            </v-col>

            <!-- <v-col class="d-flex  justify-end">
                <v-spacer />
                <v-btn @click="print()" small color="success">
                    <v-icon> mdi-print </v-icon>
                    {{$t('print')}}
                </v-btn>
            </v-col> -->
        </v-row>
        <div
            v-if="resetAllFilter"
            class="d-flex flex-column justify-center align-center"
            :style="{ height: !addPrice ? `${$vuetify.breakpoint.height - 90}px` : `${$vuetify.breakpoint.height - 211}px`}"
        >
            <v-progress-circular
                v-if="loading"
                color="primary"
                indeterminate
                size="44"
                width="4"
            />
            <template v-else>
                <v-icon size="60" class="mb-1">mdi-invoice-list</v-icon>
                <span class="text-h6">{{$t('SamplesStatement.please-select-a-filter')}}</span>
            </template>
        </div>

		<!-- table -->
		<bee-handy-table
            id="content-to-print"
            v-if="!resetAllFilter"
            ref="table"
			:items="[]"
			:headers="headers"
			dense
			zebra
			class="mt-6"
            hide-default-footer
            :loading="loading"
            :height="addPrice ? $vuetify.breakpoint.height - (40 + 35 + 80 + 48 + 50) : $vuetify.breakpoint.height - (40 + 35 + 80)"
            fixed-header
            pagination-on-scroll
            :pagination-on-scroll-auto-reset-shown="false"
            pagination-on-scroll-server-items
            :items-per-page="20"
            :scroll-options.sync="scrollOptions"
            :server-items-length="serverItemsLength"
            @pagination-on-scroll:reach-last-row="fetchAll"
            :shown-rows-text="$t('shown-rows')"
		>
            <!-- <template v-slot:item.accountId="{ item }">
                {{  }}
            </template> -->
            <template v-slot:item.sellPrice="{ item }">
                {{ item.in ? item.in.sellPrice !== null ? item.in.sellPrice : '-' : item.out.sellPrice !== null ? item.out.sellPrice : '-' }}
            </template>
            <template v-slot:item.notes="{ item }">
				<v-icon 
					v-if="item.description && item.description.includes('Transaction from visit')" 
					color="success"
				> 
					mdi-check-circle 
				</v-icon>
				<v-icon 
					v-else
					color="alert-color"
				> 
					mdi-close-circle 
				</v-icon>
			</template>
        </bee-handy-table>

        <!-- footer -->
        <v-footer v-if="addPrice && !resetAllFilter " color="grey lighten-3" padless>
            <v-col
                class="text-center"
                cols="12"
            >
                {{ $t('SamplesStatement.total-sales') }} : <strong> {{ totalSales ? totalSales : 0 }} </strong>
            </v-col>
        </v-footer>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { excelFile, addPrice, isDisabledFriday } from '@/configs/global.config'
import { disableDates } from '@/helpers/functions'
export default {
    watch: {
        isOut(val) {
            if (val === true) {
                this.isIn = false
            }
        },
        isIn(val) {
            if (val === true) {
                this.isOut = false
            }
        }
    },
    data () {
        return {
            excelFile,
            loading: false,
            loadingExcel: false,
            resetAllFilter: true,
            items: [],
			entities: [],
            item: null,
            startDate: null,
            endDate: null,
            name: null,
            typeAccount: null,
            names: [],
            submitLoading: false,
            summary: [],
            needToResetItems: false,
            scrollOptions: {},
            serverItemsLength: 0,
            // isInOrOut: null,
            isIn: null,
            isOut: null,
            addPrice,
            totalSales: 0,
            isDisabledFriday,
            disableDates
        }
    },

    computed: {
        ...mapState({ 
            materials: state => state.materials.materials,
            materialForms: state => state.materialForms.materialForms,
            supervisors: state => state.supervisors.supervisors,
            medicalRepsBrief: state => state.medicalreps.medicalRepsBrief,
            isSuperAdmin: state => state.auth.isSuperAdmin,
            accounts: state => state.accounts.accounts,
            staff: state => state.accounts.staff
        }),

        ...mapGetters({
            isAdmin: 'auth/isAdmin',
            getMaterialById: 'materials/getMaterialById',
            getAccountById: 'accounts/getAccountById'
        }),

        isAllFieldsEmpty(){
            return this.typeAccount === null && this.name === null && this.item === null && this.startDate === null && this.endDate === null;
        },

        type() {
            return [
				{ accountId: 1, name: this.$t('SamplesStatement.customers'), },
				{ accountId: 2, name: this.$t('SamplesStatement.external-entities'), },
				{ accountId: 0, name: this.$t('SamplesStatement.staff'), }
			]
        },

        headers() {        
            const headers = [
                {
                    text: this.$t('headers.account'),
                    name: 'accountId',
                    value: 'accountId',
                    setValueExpr: val => val ? this.staff.find(c => c.accountId === val)?.name : '-'
                },
                {
                    text: this.$t('headers.input-quantity'),
                    name: 'Input-quantity',
                    value: 'in',
                    setValueExpr: val => val !== null ? val.amount : '-'
                },
                {
                    text: this.$t('headers.output-quantity'),
                    name: 'output-quantity',
                    value: 'out',
                    setValueExpr: val => val !== null ? val.amount : '-'
                },
                {
                    text: this.$t('headers.from-to-account'),
                    name: 'fromToAccountName',
                    value: 'fromToAccountName',
                },
                {
                    text: this.$t('headers.notes'),
                    name: 'description',
                    value: 'description',
                    setValueExpr: val => val ? val.includes('Transaction from visit') ? '- ' : val : '-'
                },
                {
                    text: this.$t('headers.transaction-from-visit'),
                    name: 'notes',
                    value: 'notes',
					setValueExpr: val => val ? val.includes('Transaction from visit') : ' ',
                    type: 'string',
					noInput: true,
					sortable: false
                },
                {
                    text: this.$t('headers.material'),
                    name: 'material',
                    value: 'materialId',
                    setValueExpr: val => this.getMaterialById(val)?.name
                },
                {
                    text: this.$t('headers.date'),
                    name: 'date',
                    value: 'date',
                    setValueExpr: val => moment(val).format('YYYY-MM-DD')
                }
            ]
            if (this.addPrice) {
                headers.splice(4, 0,
                    {
                        text: this.$t('headers.sell-price'),
                        name: 'sellPrice',
                        value: 'sellPrice',
                        noNotAvailableText: true
                    },
                )
            }
            return headers
        },
        inOrOut() {
            let isInOrOut = null
            if (this.isIn === false && this.isOut === false) {
                isInOrOut = null
            } else if (this.isIn === false && this.isOut === true) {
                isInOrOut = false
            } else if (this.isIn === true && this.isOut === false) {
                isInOrOut = true
            }
            return isInOrOut
        }
    },

	methods: {	
        moment,
        importExcel() {
            this.loadingExcel = true
            this.$store.dispatch('exporter/fetchStatementExport', { MaterialId: this.item, FromDate: this.startDate, ToDate: this.endDate, AccountId: this.name, Type: this.typeAccount }).finally(() => {
                this.loadingExcel = false
            })
        },
        reset() {
            this.item = null
            this.startDate = null
            this.endDate = null
            this.name = null
            this.typeAccount = null
            this.resetAllFilter = true
        },

        getName() {
            this.submitLoading = true
            this.$store.dispatch('accounts/fetchAllBrief', { type: this.typeAccount, regionIds: [] }).then((data) => {
                // console.log(data)
                this.names = data
                this.submitLoading = false
            }).finally(() => {
                this.submitLoading = false
            })
        },

        fetchAll(newOptionsScroll) {
            this.loading = true;
            let page = 1;

            const { itemsPerPage } = this.scrollOptions;

            if (newOptionsScroll) {
                page = newOptionsScroll.page;
            }
            this.$store.dispatch('materialTransactions/fetchStatement', { 
                type: this.typeAccount,
                date: this.moment().format('YYYY-MM-DD'), 
                MaterialId: this.item, 
                FromDate: this.startDate, 
                ToDate: this.endDate, 
                AccountId: this.name, 
                Page: page, 
                PerPage: itemsPerPage,
                regionIds: [],
                isInput: this.inOrOut
            }).then(({ data, total }) => {
                // if (data.length) {
                if (this.needToResetItems) { 
                    this.$refs.table.resetShownRows();
                    this.needToResetItems = false;
                }
                const entities = data.map(c => ({ 
                    ...c, 
                    materialId: c.in ? c.in.materialId : c.out.materialId
                }));
                this.$refs.table.addScrollItems(entities)
                this.entities = entities
                this.serverItemsLength = total;
                this.totalSales = this.addPrice ? data[0].totalSales : 0
                // }
            }).finally(() => {
                this.loading = false;
            })
        },

        print() {
            const printWindow = window.open('/invoice.html', '_blank');

            // الانتظار حتى يتم تحميل الصفحة ثم تنفيذ الطباعة
            printWindow.onload = function() {
                printWindow.print(); // طباعة الصفحة
            }
	    },
    },

    created () {
        this.loading = true
        Promise.all([
            this.$store.dispatch('materials/fetchAll'),
            this.$store.dispatch('materialForms/fetchAll'),
            !this.medicalRepsBrief.length ? this.$store.dispatch('medicalreps/fetchAllBrief', true) : null,
        ]).then(() => {
            // this.fetchAll()
        }).finally(() => {
            this.loading = false
        })
    } 

}
</script>

<style scoped>

</style>